// extracted by mini-css-extract-plugin
module.exports = {"item":"tKun6","name":"s1Iqw","price":"e09Rz","radio":"ZaDG9"};